import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const today = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

export default function MarkReceivedDialog({ open, onOpenChange, transaction, onDone }) {
  const [date, setDate] = useState(today());
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && transaction) {
      setDate(transaction.transaction_date || today());
      setAmount(transaction.amount ?? "");
    }
  }, [open, transaction]);

  const submit = async () => {
    setLoading(true);
    try {
      await api.post(`/transactions/${transaction.id}/complete`, { received_date: date, actual_amount: amount });
      toast.success("Virement marqué comme reçu");
      onOpenChange(false);
      onDone && onDone();
    } catch (e) { toast.error(apiErr(e)); } finally { setLoading(false); }
  };

  if (!transaction) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl sm:max-w-sm" data-testid="mark-received-dialog">
        <DialogHeader><DialogTitle className="font-display text-lg">Marquer le virement reçu</DialogTitle></DialogHeader>
        <div className="space-y-4 pt-2">
          <p className="text-sm text-gray-500">{transaction.label}</p>
          <div>
            <Label>Date de réception réelle</Label>
            <Input data-testid="received-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1.5 rounded-xl" />
            <p className="mt-1 text-xs text-gray-400">Le CA sera rétrocédé sur le mois de cette date.</p>
          </div>
          <div>
            <Label>Montant réellement reçu (€)</Label>
            <Input data-testid="received-amount" type="number" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} className="mt-1.5 rounded-xl" />
          </div>
          <Button data-testid="confirm-received" onClick={submit} disabled={loading} className="w-full rounded-full bg-[#065F46] py-6 hover:bg-[#047857]">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Confirmer la réception"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
